import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { params, string as stringType, shape, useDataModel } from '@thd-nucleus/data-sources';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './article-info.module.scss';

export const ArticleInfoIntroduction = ({ articleGUID }) => {
  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID },
  });

  if (loading || error || !data) return null;

  const introduction = data?.article?.introduction || '';

  const headerType = data?.article?.articleHeader?.type;
  const isVideo = headerType && headerType === 'video';

  const articleType = data?.article?.articleType || 'ap';
  const articleTypeMappings = {
    ab: 'Buying Guide',
    ai: 'Inspiration Guide',
    ah: 'Project Guide',
    ap: 'Influencer Guide',
  };
  const isProjectGuide = articleTypeMappings[articleType] === articleTypeMappings.ah;
  const isInfluencerGuide = articleTypeMappings[articleType] === articleTypeMappings.ap;

  const introductionClasses = classNames(styles['article-info__introduction'], {
    [styles['article-info__introduction--top-margin']]: isProjectGuide || isVideo,
    [styles['article-info__introduction--full-width']]: !!isVideo
  });

  return (
    <div className={introductionClasses}>
      {isInfluencerGuide
        ? <h2>A Note From The Home Depot</h2>
        : ''}
      {ReactHtmlParser(introduction, {
        /* eslint-disable-next-line consistent-return */
        transform(node) {
          if (node.type === 'tag' && node.name === 'strong') {
            return node.children.map((child) => child.data).join('');
          }
        },
      })}
    </div>
  );
};

ArticleInfoIntroduction.propTypes = {
  articleGUID: string.isRequired,
};

ArticleInfoIntroduction.displayName = 'ArticleInfoIntroduction';

ArticleInfoIntroduction.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    introduction: stringType(),
    articleType: stringType(),
    articleHeader: shape({
      type: stringType(),
    }),
  }),
};
